import { useQuery } from '@tanstack/react-query';
import type { TradePlanPreviewInput, TradePlanStatus } from 'shared';

import { listTradePlans, previewTradePlan } from '../../lib/api/endpoints';

export const tradePlanKeys = {
  all: ['trade-plans'] as const,
  list: (status?: TradePlanStatus) => ['trade-plans', status ?? 'all'] as const,
};

export function useTradePlans(status?: TradePlanStatus) {
  return useQuery({
    queryKey: tradePlanKeys.list(status),
    queryFn: () => listTradePlans(status),
  });
}

export function useTradePlanPreview(input: TradePlanPreviewInput | null) {
  return useQuery({
    queryKey: ['trade-plan-preview', input] as const,
    queryFn: () => {
      if (!input) throw new Error('Trade-plan preview input is required.');
      return previewTradePlan(input);
    },
    enabled: input !== null,
    staleTime: 0,
  });
}
